/**
 * Gift subscription PDP — handoff delivery tiles + live Shopify variant pricing.
 */
(function () {
  'use strict';

  function fmt(cents) {
    if (window.ZZAI?.fmt) return window.ZZAI.fmt(cents);
    const n = Number(cents) || 0;
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(
      n / 100
    );
  }

  function init(root) {
    const form = root.querySelector('.gft-product-form');
    if (!form) return;

    const variantInput = form.querySelector('[data-gft-variant-input]');
    const deliveriesInput = form.querySelector('[data-gft-deliveries-input]');
    const bigPrice = root.querySelector('[data-gft-big-price]');
    const perLine = root.querySelector('[data-gft-per-line]');
    const options = Array.from(root.querySelectorAll('.gft-deliv-opt[data-variant-id]'));
    const sectionId = root.id.replace(/^zzai-gs-/, '');
    const mobileDock = document.querySelector('[data-gift-mobile-dock="' + root.id + '"]');
    const mobileQty = document.getElementById('gft-mobile-qty-' + sectionId);
    const mobileTotal = document.getElementById('gft-mobile-total-' + sectionId);
    const mobileSubmit = document.getElementById('gft-mobile-submit-' + sectionId);
    const mobileEdit = document.getElementById('gft-mobile-edit-' + sectionId);
    let formInView = false;

    const qtyInput = form.querySelector('[data-gft-qty-input]');
    const qtyMinus = form.querySelector('[data-gft-qty-minus]');
    const qtyPlus = form.querySelector('[data-gft-qty-plus]');
    const minQty = parseInt(qtyInput?.dataset?.minQty || '2', 10);

    function currentQty() {
      return parseInt(qtyInput?.value || minQty, 10) || minQty;
    }

    function optionPerDeliveryCents(btn) {
      return parseInt(btn?.dataset?.perDeliveryCents || '0', 10) || 0;
    }

    function optionPriceCents(btn) {
      return parseInt(btn?.dataset?.priceCents || '0', 10) || 0;
    }

    function optionDeliveries(btn) {
      return parseInt(btn?.dataset?.deliveries || '1', 10) || 1;
    }

    function updateOptionDisplay(btn) {
      if (!btn) return;
      const perDelivery = optionPerDeliveryCents(btn) * currentQty();
      const total = optionPriceCents(btn) * currentQty();
      const per = btn.querySelector('[data-gft-option-per]');
      const totalEl = btn.querySelector('[data-gft-option-total]');
      if (per) per.textContent = `${fmt(perDelivery)} per shipment`;
      if (totalEl) totalEl.textContent = `${fmt(total)} charged today`;
    }

    function updateAllOptionDisplays() {
      options.forEach(updateOptionDisplay);
    }

    function updatePrice(btn) {
      if (!btn) return;
      const deliveries = optionDeliveries(btn);
      const perDelivery = optionPerDeliveryCents(btn) * currentQty();
      const total = optionPriceCents(btn) * currentQty();
      if (bigPrice) bigPrice.textContent = fmt(total);
      if (perLine) perLine.textContent = `${fmt(perDelivery)} per shipment · ${deliveries} ${deliveries === 1 ? 'shipment' : 'shipments'}`;
      if (mobileQty) {
        const qty = currentQty();
        mobileQty.textContent = qty + ' ' + (qty === 1 ? 'tray' : 'trays');
      }
      if (mobileTotal) mobileTotal.textContent = fmt(total);
      if (mobileDock) {
        mobileDock.classList.toggle('is-hidden', formInView);
        mobileDock.classList.toggle('is-visible', !formInView);
      }
    }

    function setQty(n) {
      if (!qtyInput) return;
      const max = parseInt(qtyInput.max || '24', 10);
      const clamped = Math.max(minQty, Math.min(max, n));
      qtyInput.value = clamped;
      if (qtyMinus) qtyMinus.disabled = clamped <= minQty;
      const active = options.find((b) => b.classList.contains('active'));
      updateAllOptionDisplays();
      if (active) updatePrice(active);
    }

    if (qtyMinus) qtyMinus.addEventListener('click', () => setQty(currentQty() - 1));
    if (qtyPlus)  qtyPlus.addEventListener('click',  () => setQty(currentQty() + 1));
    if (mobileSubmit) {
      mobileSubmit.addEventListener('click', () => {
        const submit = form.querySelector('button[type="submit"], input[type="submit"]');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit || undefined);
        else if (submit) submit.click();
      });
    }
    if (mobileEdit) {
      mobileEdit.addEventListener('click', () => {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    if (mobileDock && typeof IntersectionObserver !== 'undefined') {
      const obs = new IntersectionObserver(
        (entries) => {
          formInView = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.18);
          mobileDock.classList.toggle('is-hidden', formInView);
          mobileDock.classList.toggle('is-visible', !formInView);
        },
        { threshold: [0, 0.18, 0.45] }
      );
      obs.observe(form);
    }

    function selectOption(btn) {
      if (!btn || btn.disabled) return;
      options.forEach((b) => {
        b.classList.toggle('active', b === btn);
        b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
      });
      const id = btn.dataset.variantId;
      const deliveries = btn.dataset.deliveries || '1';

      if (variantInput) variantInput.value = id;
      if (deliveriesInput) deliveriesInput.value = deliveries;
      updateAllOptionDisplays();
      updatePrice(btn);
    }

    options.forEach((btn) => {
      btn.addEventListener('click', () => selectOption(btn));
    });

    const active = options.find((b) => b.classList.contains('active')) || options.find((b) => !b.disabled);
    if (active) selectOption(active);
    setQty(minQty);
  }

  function boot() {
    document.querySelectorAll('.zzai-gift-subscription-main').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
